<div class="container-fluid mt-4">
  <div class="card" style="margin-bottom: 2em">
    <div class="card-header">
      <h3>App Configuration</h3>
      <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="palette" size="lg" [fixedWidth]="true"></fa-icon>
    </div>
    <div class="card-body d-flex flex-column gap-4">
      <div>
        <div class="row my-4">
          <label class="col-2 col-form-label">App Name</label>
          <div class="col-10">
            <app-button-input
              [initialValue]="name"
              [(value)]="newName"
              [disabled]="name === newName"
              (apply)="changeNames(true, false)"
              (cancel)="changeNames(false, false)"
            ></app-button-input>
          </div>
        </div>
        <div class="row my-4">
          <label class="col-2 col-form-label">App Short Name</label>
          <div class="col-10">
            <app-button-input
              [initialValue]="shortName"
              [(value)]="newShortName"
              [disabled]="shortName === newShortName"
              (apply)="changeNames(false, true)"
              (cancel)="changeNames(false, false)"
            ></app-button-input>
          </div>
        </div>
      </div>
      <div>
        <h4>App Colors:</h4>
        <app-app-color-selector [(colors)]="appColors" (updateColors)="updateAppColors($event)"></app-app-color-selector>
      </div>
      <div class="row justify-content-between">
        <div class="col-5">
          <h4>App Logo and Favicon:</h4>
          <app-icon-exchange></app-icon-exchange>
        </div>
        <div class="col-6">
          <h4>Login Logo:</h4>
          <app-logo-exchange></app-logo-exchange>
        </div>
      </div>
      <div>
        <h4>Wiki Colors</h4>
        <app-theme-color-selector [(colors)]="wikiColors" (updateColors)="updateWikiColors($event)"></app-theme-color-selector>
      </div>
    </div>
  </div>
  <div class="card my-4">
    <div class="card-header">
      <h3>App Structure</h3>
      <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="cog" size="lg" [fixedWidth]="true"></fa-icon>
    </div>
    <div class="card-body" *ngIf="rules">
      <div *ngFor="let rule of rules">
        <h4>{{rule.depth + 1}}. {{rule.label || 'Level'}}</h4>
        <ul class="list-group">
          <li class="list-group-item">
            <div class="row">
              <label class="col-2 col-form-label">Label</label>
              <div class="col-10">
                <app-button-input
                  [initialValue]="rule.label || ''"
                  [(value)]="rule.newLabel"
                  [disabled]="rule.label === rule.newLabel"
                  (apply)="changeLabel(rule.depth, rule.newLabel)"
                  (cancel)="changeLabel(rule.depth, rule.label)"
                ></app-button-input>
              </div>
            </div>
          </li>
          <li class="list-group-item" *ngIf="rule.menu === 'slider'">
            <configuration-menu-hero-slider
              [rule]="rule"
              (updateSlides)="uploadMenuFeatureSlides($event, rule.depth)"
            ></configuration-menu-hero-slider>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
